define('app/views/sale_view',[
  'app/setup', 'app/models/configurable_options',
  'app/views/configurable_options_view', 'app/views/add_to_cart_form_view',
  'app/views/buy_button_view', 'app/views/grouped_buy_button_view',
  'app/views/gift_button_view',
  'app/views/grouped_gift_button_view',
  'app/views/mobile_only_buy_button_view'
], function(
  takhfifan, configurableOptions, configurableOptionsView,
  addToCartFormView,
  buyButtonView, groupedBuyButtonView, giftButtonView,
  groupedGiftButtonView,
  MobileOnlyBuyButtonView
) {

  takhfifan.SaleView = Backbone.View.extend({

    initialize: function(options) {
      this.loadConfigurableOptions();
      this.soldTemplate = _.template(this.$('.tkh-sold').first().data('template'));
      this.model.on('change', this.render, this);
      this.collection.on('change', this.checkAllCollection, this);
      this.collection = options.collection;
      this.generateAddToCartForm();
      this.loadBuyButton();
      this.noteBox = $('.extra-info-box');
      this.noteBox.hide();

      takhfifan.eventHub.on('timeover:' + this.$el.data('product-id'),
        function() {
          this.disable();
        }, this);

      takhfifan.eventHub.on('session:showMugInfo', function (data) {
        if (data === 'show') {
          this.noteBox.show();
        } else {
          this.noteBox.hide();
        }
      }, this);

      takhfifan.eventHub.trigger('ga:productDetailImpression', this.$el.data('details'));
    },

    generateAddToCartForm: function() {
      if (this.$el.data('can-checkout') == 1) {
        var productId = this.$el.data('product-id');

        var $form = $('<form />').prop({
          method: 'post',
          action: '#',
        }).css('display', 'none');

        this.$el.append($form);

        new takhfifan.AddToCartFormView({
          el: $form,
          productId: productId
        });
      }
    },

    checkAllCollection: function(){
      if(this.$el.find('.tkh-grouped-buy-btn').length){
        var haveOneChild = false,
          myId = this.model.get('id');
        for(var i=0, l = this.collection.length; i< l; i++) {
          var model = this.collection.models[i];
          if(myId !== model.get('id') && !model.get('expired') && !model.get('isSoldOut')){
            haveOneChild = true;
          }
        }
        if(!haveOneChild){
          this.$el.find('.tkh-grouped-buy-btn').attr('disabled', true);
          this.$el.find('.tkh-grouped-gift-btn').attr('disabled', true);
          this.disable();
        }
      }
    },

    loadBuyButton: function() {
      var productId = this.$el.data('product-id'),
          _this = this;
      this.$('.tkh-buy-btn').each(function() {
        new takhfifan.BuyButtonView({
          el: $(this),
          productId: productId
        });
      });

      this.$('.tkh-grouped-buy-btn').each(function() {
        new takhfifan.GroupedBuyButtonView({
          el: $(this),
          productId: productId,
          collection: _this.collection
        });
      });

      this.$('.thk-mobile-only-buy-btn').each(function() {
        new takhfifan.MobileOnlyBuyButtonView({
          el: $(this),
          productId: productId
        });
      });

      this.$('.tkh-gift-btn').each(function() {
        new takhfifan.giftButtonView({
          el: $(this),
          productId: productId
        });
      });

      this.$('.tkh-grouped-gift-btn').each(function() {
        new takhfifan.GroupedGiftButtonView({
          el: $(this),
          productId: productId,
          collection: _this.collection
        });
      });

    },

    render: function(args) {
      this.$('.tkh-sold').html(this.soldTemplate({
        i: this.model.get('sold')
      }));
      this.$('.tkh-available').text(this.model.get('available'));
    },

    loadConfigurableOptions: function() {
      this.$('.tkh-configurable-options').each(function() {
        var $el = $(this);
        var dealId = parseInt($el.data('product-id'));
        var config = _tkhProductOptions;
        var configurableOptions = new takhfifan.ConfigurableOptions({
          id: dealId,
          basePrice: config.basePrice,
          superAttributes: _.map(config.attributes, function(sa) {
            return sa.id;
          })
        });
        new takhfifan.ConfigurableOptionsView({
          el: $el,
          model: configurableOptions,
          config: config
        });
      });
    },

    disable: function() {
      //this.$el.addClass('finish');
      this.$('form').remove();
      //this.$('.main-deal-text').empty();
      //$('.finished-hidden-cnt-container .finish-cnt').appendTo(this.$('.main-deal-text'));
    }

  });

});

